import { Box, Grid, Link, styled } from "@mui/material";
import { AxiosError } from "axios";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiRoutes } from "../configuration/apiRoutes";
import { Translations } from "../localization/translations";
import { LodResourceListResponse } from "../models/LodResourceListResponse";
import PageContent from "../parts/page-content/PageContent";
import { RestService } from "../utils/axios";
import {Link as RouterLink, useParams} from "react-router-dom";
import useKlasisRouting from "../utils/klasisRouting";

const Item = styled(Grid)(({ theme }) => ({
    wordWrap: "break-word",
    borderColor: theme.palette.divider,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    padding: "1rem 0"
}));

const HeaderItem = styled(Item)(() => ({
    fontWeight: "bold",
    marginBottom: "1rem"
}));

const LodResources: React.FC = () => {
    let { locale } = useParams();

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<LodResourceListResponse>();

    const { t } = useTranslation();
    const { klasisRoute } = useKlasisRouting();

    useEffect(() => {
        getData();
    }, [locale]);

    const getData = (): void => {
        setIsLoading(true);

        RestService.Get<LodResourceListResponse>(
            ApiRoutes.Lod.Resources({ localeCode: locale ?? "lv-LV" }),
            (response: LodResourceListResponse) => {
                setData(response);
            },
            (error: AxiosError) => {
                console.log("Error: " + error.message);
            },
            () => {
                setIsLoading(false);
            }
        );
    }

    return (
        <PageContent
            title={t(Translations.pages.title.lodResources)}
            showBreadcrumbs={true}
            showTitleBarCommands={true}
            isLoading={isLoading}
        >
            <Grid container spacing={2}>
                <HeaderItem item xs={3} sm={2}>
                    {t(Translations.lod.label.code)}
                </HeaderItem>
                <HeaderItem item xs={6} sm={7}>
                    {t(Translations.lod.label.classifierTitle)}
                </HeaderItem>
                <HeaderItem item xs={3} sm={3}>
                    {t(Translations.lod.label.topLevelResource)}
                </HeaderItem>
                {data?.items.map(item => {
                    return (
                        <Fragment key={item.code}>
                            <Item item xs={3} sm={2}>
                                {item.code}
                            </Item>
                            <Item item xs={6} sm={7}>
                                {item.classifierTitle}
                            </Item>
                            <Item item xs={3} sm={3}>
                                <Link
                                    component={RouterLink}
                                    to={klasisRoute(`lod-resources/${encodeURIComponent(item.code)}`)}
                                >
                                    {item.subject}
                                </Link>
                            </Item>
                        </Fragment>
                    );
                })}
            </Grid>
        </PageContent>
    );
}

export default LodResources;